import { Component, computed, input, Signal } from '@angular/core';
import {
  MuiSkeletonAnimationType,
  MuiSkeletonColor,
  MuiSkeletonTextLine,
  MuiSkeletonTextVariant
} from '../shared/mui-skeleton-types';


@Component({
  selector: 'mui-skeleton-text',
  standalone: true,
  templateUrl: './mui-skeleton-text.component.html',
  styleUrls: ['./mui-skeleton-text.component.scss', '../shared/mui-skeleton.scss']
})
export class MuiSkeletonTextComponent {
  lines = input<MuiSkeletonTextLine>(0);
  variant = input<MuiSkeletonTextVariant>('body');
  color = input<MuiSkeletonColor>('light');

  animated = input<MuiSkeletonAnimationType>('wave');

  linesArray: Signal<(string | number)[]> = computed((): (string | number)[] => {
    if (Array.isArray(this.lines())) {
      return this.lines() as (string | number)[];
    } else if (typeof this.lines() === 'number' && (this.lines() as number) > 0) {
      const generatedLines = [];
      for (let line = 0; line < (this.lines() as number); line++) {
        generatedLines.push(this.randomWidth());
      }
      return generatedLines;
    } else {
      return [];
    }

  });

  computedWidth(line: string | number): string | number {
    let width = undefined;
    if (line.toString().endsWith('%')) {
      width = line.toString().slice(0, -1);
    } else if (/^\d+$/.test(line.toString())) {
      width = line;
    }
    if (width !== undefined) {
      return (parseInt(width.toString(), 10) < 101 ? width : 100) + '%';
    }
    return line;
  }

  randomWidth(): string { // min and max included
    return Math.floor(Math.random() * 61 + 40).toString();
  }
}
